import { useState } from "react";
import { Loader2, Plus, LogIn } from "lucide-react";
import { Input } from "@/components/ui/input";

export function TeamSetup({ onCreate, onJoin, busy }) {
  const [name, setName] = useState("");
  const [code, setCode] = useState("");
  const btn = "h-12 px-4 rounded-xl font-bold flex items-center justify-center gap-2 transition-colors disabled:opacity-40";

  return (
    <div className="space-y-4">
      <p className="text-slate-600">Comparez vos séries de jours avec les collègues du chantier.</p>
      <form
        onSubmit={(e) => { e.preventDefault(); onJoin(code); }}
        className="bg-white rounded-2xl border-2 border-slate-200 p-5 space-y-3 rise"
        data-testid="team-join-form"
      >
        <p className="font-display text-xl font-bold uppercase">Rejoindre une équipe</p>
        <div className="flex gap-2">
          <Input
            value={code}
            onChange={(e) => setCode(e.target.value.toUpperCase().slice(0, 6))}
            placeholder="CODE"
            className="h-12 text-lg font-bold tracking-[0.3em] uppercase"
            data-testid="team-join-code-input"
          />
          <button type="submit" disabled={code.length !== 6 || busy} className={`${btn} bg-orange-500 hover:bg-orange-600 text-white`} data-testid="team-join-btn">
            {busy === "join" ? <Loader2 className="w-5 h-5 animate-spin" /> : <LogIn className="w-5 h-5" />} Entrer
          </button>
        </div>
      </form>
      <form
        onSubmit={(e) => { e.preventDefault(); onCreate(name); }}
        className="bg-white rounded-2xl border-2 border-slate-200 p-5 space-y-3 rise rise-1"
        data-testid="team-create-form"
      >
        <p className="font-display text-xl font-bold uppercase">Créer une équipe</p>
        <div className="flex gap-2">
          <Input
            value={name}
            onChange={(e) => setName(e.target.value)}
            maxLength={40}
            placeholder="Ex : Chantier Montreuil"
            className="h-12 text-base"
            data-testid="team-create-name-input"
          />
          <button type="submit" disabled={!name.trim() || busy} className={`${btn} bg-slate-900 hover:bg-slate-800 text-white`} data-testid="team-create-btn">
            {busy === "create" ? <Loader2 className="w-5 h-5 animate-spin" /> : <Plus className="w-5 h-5" />} Créer
          </button>
        </div>
      </form>
    </div>
  );
}
